
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.229 9.456a.6.6 0 0 0 .846.851zm3.682-2.812.423.426a.6.6 0 0 0 0-.852zm-2.836-3.663a.6.6 0 1 0-.846.851zm1.588 4.262a.6.6 0 1 0 0-1.2zm-6.902-1.2a.6.6 0 0 0 0 1.2zm5.314 4.264 3.259-3.237-.846-.852-3.259 3.238zm3.259-4.089-3.26-3.237-.845.851 3.26 3.238zm-1.671-.175H6.76v1.2h6.902z","fill":"#2a2b2e"}}),_c('path',{attrs:{"d":"M7.608 1.167H3.333a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h4.275","stroke":"#2a2b2e","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    